import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rt-offer-status-indicator',
  templateUrl: './offer-status-indicator.component.html',
  styleUrls: ['./offer-status-indicator.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'statusType',
  },
})
export class OfferStatusIndicatorComponent {
  @Input() public offer: { kind: 'job' | 'talent_pool'; status: string }; // TODO: replace this input by 'offerStatus'

  public get statusType(): string {
    if (this.offer.kind === 'talent_pool') {
      return 'talent-pool';
    } else {
      return this.offer.status;
    }
  }
}
